import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

export default function Menu() {
  const data = useStaticQuery(graphql`
    query HeaderMenuQuery {
      datoCmsMenu {
        lhsMenuLinks {
          id
          title
          link
          image {
            gatsbyImageData
          }
        }
      }
    }
  `)
  const links = data?.datoCmsMenu?.lhsMenuLinks || []
  const openContact = type => {
    window.dispatchEvent(new CustomEvent("open-contact-overlay", { detail: { type } }))
  }
  return (
    <div className='mobile--menu'>
      <div className='p16 mth inner flex flex-col gap-8'>
        {links.map(item => (
          <MenuLink key={item.id} link={item} />
        ))}
        <Link data-title='Partners' to='/partners'>Partners</Link>
        <p className='pointer' role='presentation' onClick={() => openContact("trade")} activeClassName='active'>Trade</p>
        <p className='pointer' role='presentation' onClick={() => openContact("general")} activeClassName='active'>Contact</p>
      </div>
    </div>
  )
}

const MenuLink = ({link}) => {
  return (
    <Link data-title={link.title} to={link.link} className='flex space-between'>
      <p>{link.title}</p>
      <div className='menu--thumbnail ratio-3-4 bg-grey pos-rel'>
        <GatsbyImage image={link.image.gatsbyImageData} alt='' className='bg-image' />
      </div>
    </Link>
  )
}